export default __webpack_public_path__ + "static/media/shashankr3.9ef85ee4.png";